import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import Login from './pages/Login';
import LicenseList from './pages/LicenseList';
import TestLicenseView from './pages/TestLicenseView';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import NotFoundPage from './pages/NotFoundPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import VersionRouter from './components/VersionRouter';
import { AuthProvider } from './context/AuthContext';
import './App.css';

// 引入Ant Design CSS
import 'antd/dist/reset.css';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* 公开查看营业执照（通过URL参数） */}
            <Route path="/" element={<VersionRouter />} />
            
            {/* 登录页面 */}
            <Route path="/login" element={<Login />} />
            
            {/* 管理员路由 */}
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="" element={<Navigate to="/admin/licenses" replace />} />
                <Route path="licenses" element={<LicenseList />} />
              </Route>
            </Route>
            
            {/* 营业执照查看页（通过路径参数） */}
            <Route path="/license/:id" element={<VersionRouter />} />
            
            {/* 测试页面 */}
            <Route path="/test" element={<TestLicenseView />} />
            <Route path="/test/:id" element={<TestLicenseView />} />
            
            {/* 特殊页面 */}
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            
            {/* 重定向 */}
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
